import axios from "axios";
import { AGENT_API_URL } from "../../config/config";
import { api_urls } from "../../utilities";
import { getAuthorizationHeader } from "./authHeader";

export const patchAgentService = (api, data, showError = true) => {
  const authHeader = getAuthorizationHeader();
  const config = {
    headers: {
      token: api_urls.service_token,
      ...(authHeader ? { Authorization: authHeader } : {}),
    },
  };

  return axios
    .patch(AGENT_API_URL + api, data ?? {}, config)
    .then((res) => res)
    .catch((error) => {
      if (showError) {
        console.error(
          "[patchAgentService]",
          AGENT_API_URL + api,
          error?.response || error
        );
      }
      throw error.response || error;
    });
};

export const patchService = (api, data, showError = true) => {
  const authHeader = getAuthorizationHeader();
  const config = {
    headers: {
      token: api_urls.service_token,
      ...(authHeader ? { Authorization: authHeader } : {}),
    },
  };

  return axios
    .patch(api_urls.base_url + api, data ?? {}, config)
    .then((res) => res)
    .catch((error) => {
      if (showError) {
        console.error(
          "[patchService]",
          api_urls.base_url + api,
          error?.response || error
        );
      }
      throw error.response || error;
    });
};
